import React, { useContext } from 'react';
import {
	ICreateSubcategoryModalContext,
	CreateSubcategoryModalContext,
} from '../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import ModalSentErrorWithInfo from './ModalSentErrorWithInfo/ModalSentErrorWithInfo';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { changeTypeOfModalWindow, showErrorModalWithInfo, typeOfModalWindow, errorResponseData } =
		useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);
	const { updateCollectionOfCategories, changeIsShowModalWindowToCreateSubcategory } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow || errorResponseData });

	const handleConsentEvent = () => {
		changeTypeOfModalWindow(null);
		updateCollectionOfCategories();
		changeIsShowModalWindowToCreateSubcategory(false);
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalSentSuccessfully
				onConsentEvent={handleConsentEvent}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'fileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={{ size: '10MB' }}
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'fileUploadError'}
				description="fileUploadError"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'invalidFileFormat'}
				description="invalidFileFormatPhoto"
				translationOptions={{ formats: '.jpeg, .jpg, .png' }}
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'defaultTranslationIsEmpty'}
				description="errorDefaultTranslation"
			/>
			<ModalSentErrorWithInfo
				onConsentEvent={() => showErrorModalWithInfo(null)}
				isVisible={!!errorResponseData}
				errorResponseData={errorResponseData}
			/>
		</div>
	);
};

export default ModalWindows;
